import { AddAddress } from "../../layouts";

const Addresses = () => {
  return <AddAddress bordered={false} />;
};

export default Addresses;
